import React, { useContext, useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import auditFormStyles from "./auditFromStyles.module.css";
import {
  Divider,
  Stack,
  Grid,
  Button,
  Snackbar,
  Card,
  CardHeader,
  CardContent,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";
import { GET_AUDIT_REMARK_LIST, POST_AUDIT_REMARK } from "../../constants";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  MenuItem,
  FormControl,
  Select,
  useMediaQuery,
  useTheme,
  IconButton,
} from "@mui/material";
import { GridToolbar } from "@mui/x-data-grid";
import { DataGrid } from "@mui/x-data-grid";
import Loader from "../reusable Component/Loader";
import LongTextComponent from "../Leads Page/LongTextComponent";
import StatusChangeDialog from "./StatusChangeDialog";
import { DatePicker } from "@mui/x-date-pickers";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddRemarksDialog from "./AddRemarksDialog";

function AuditDetailsPageComponent() {
  const storedLeadDetails = JSON.parse(localStorage.getItem("leadDetails"));
  const empDetails = JSON.parse(localStorage.getItem("userData"));

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
 
  const [row, setRow] = useState([]);

  const columns = [
    // { field: "SNo", headerName: "SNo", width: 50 },
    {
      field: "Lot_Number",
      headerName: "Lot Number",
      width: isMobile ? 120 : 150,
    },
    { field: "CH", headerName: "CH", width: isMobile ? 120 : 150 },
    { field: "AGE", headerName: "AGE", width: isMobile ? 120 : 150 },
    { field: "BWT", headerName: "BWT", width: isMobile ? 120 : 150 },
    { field: "M_QTY", headerName: "M_QTY", width: isMobile ? 120 : 150 },
    {
      field: "REASON",
      headerName: "REASON",
      width: isMobile ? 120 : 190,
      renderCell: (value) => <LongTextComponent text={value} maxLength={20} />,
    },
    { field: "MED", headerName: "MED", width: isMobile ? 120 : 150 },
    { field: "FEED", headerName: "FEED", width: isMobile ? 120 : 150 },
    {
      field: "STOCK",
      headerName: "STOCK",
      width: isMobile ? 120 : 190,
      renderCell: (value) => <LongTextComponent text={value} maxLength={20} />,
    },
    { field: "IFFT_IN", headerName: "IFFT IN", width: isMobile ? 120 : 150 },
    { field: "IFFT_OUT", headerName: "IFFT OUT", width: isMobile ? 120 : 150 },
    { field: "LS_VISIT", headerName: "LS VISIT", width: isMobile ? 120 : 150 },
    { field: "BM_VISIT", headerName: "BM VISIT", width: isMobile ? 120 : 150 },
    {
      field: "DAILY_ENT",
      headerName: "DAILY ENT",
      width: isMobile ? 120 : 150,
    },
    { field: "FEED_ENT", headerName: "FEED ENT", width: isMobile ? 120 : 150 },
    { field: "MORT_ENT", headerName: "MORT ENT", width: isMobile ? 120 : 150 },
    { field: "BWT_ENT", headerName: "BWT ENT", width: isMobile ? 120 : 150 },
    {
      field: "MED_ENT",
      headerName: "MED ENT",
      width: isMobile ? 120 : 150,
      renderCell: (value) => <LongTextComponent text={value} maxLength={20} />,
    },
    {
      field: "REMARKS",
      headerName: "REMARKS",
      width: isMobile ? 120 : 150,
      renderCell: (value) => <LongTextComponent text={value} maxLength={20} />,
    },
    { field: "AgentName", headerName: "CSE Name", width: isMobile ? 120 : 150 },
    {
      field: "updatedAt",
      headerName: "Last Modified On",
      width: isMobile ? 120 : 150,
      renderCell: (params) => {
        const formattedDate = dayjs(params.value).format("YYYY-MM-DD HH:mm"); // Change the format as needed
        return formattedDate;
      },
    },
  ];

  const [runEffect, setRunEffect] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${GET_AUDIT_REMARK_LIST}/${storedLeadDetails.Lot_Number}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { auditLeadRemarks, message } = response.data;
  
        if (message) {
          // Handle the case when no remarks are found
          setRow([]);
        } else {
          // Set the remarks if they are found
          setRow(auditLeadRemarks);
        }
  
        setLoading(false);
        setRunEffect(false);
      })
      .catch((error) => {
        // Handle the error
        setLoading(false);
        setRunEffect(false);
      });
  }, [runEffect]);
  
  const handleRowData = (data) => {
    const transformedRows = [];
    var a = {};
    data.map((rd, index) => {
      a = {
        id: index + 1,
        SNo: index + 1,
        
        CH: rd.CH,
        AGE: rd.AGE,
        BWT: rd.BWT,
        M_QTY: rd.M_QTY,
        REASON: rd.REASON,
        MED: rd.MED,
        FEED: rd.FEED,
        STOCK: rd.STOCK,
        IFFT_IN: rd.IFFT_IN,
        IFFT_OUT: rd.IFFT_OUT,
        LS_VISIT: rd.LS_VISIT,
        BM_VISIT: rd.BM_VISIT,
        DAILY_ENT: rd.DAILY_ENT,
        FEED_ENT: rd.FEED_ENT,
        MORT_ENT: rd.MORT_ENT,
        BWT_ENT: rd.BWT_ENT,
        MED_ENT: rd.MED_ENT,
        REMARKS: rd.REMARKS,
        DATE: rd.DATE,
        AgentId: rd.AgentId,
        AgentName: rd.Agent.EmployeeName,
        Lot_Number: rd.Lot_Number,
        createdAt: new Date(rd.createdAt),
        updatedAt: new Date(rd.updatedAt),
      };
      transformedRows.push(a);
    });
    setRow(transformedRows);
  };

  const handleClose = (event, reason) => {
    setOpenSnackbar(false);
  };

  const [open, setOpen] = useState(false);

  return (
    <>
      {loading && <Loader open={loading} />}
      {/* Remark Form */}
      <AddRemarksDialog
        open={open}
        setOpen={setOpen}
        setSeverity={setSeverity}
        setMessage={setMessage}
        setOpenSnackbar={setOpenSnackbar}
        setAlertTitle={setAlertTitle}
        setRunEffect={setRunEffect}
      ></AddRemarksDialog>

      {/* Previous Lead Details */}
      <Card>
        <CardHeader
          title="Lead Details"
          sx={{
            padding: "10px",
            borderBottom: "1px solid #ccc",
          }}
          action={
            <Button
              variant="contained"
              color="primary"
              sx={{ right: "5px" }}
              onClick={() => setOpen((prev) => !prev)}
            >
              <AddCircleIcon fontSize="1.5rem"></AddCircleIcon>&nbsp; Add
              Remarks
            </Button>
          }
          titleTypographyProps={{
            fontSize: "1rem",
            fontWeight: 600,
          }}
          className={auditFormStyles.accordian_heading}
        />

        <CardContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Grid container spacing={2} p={1}>
              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Lot Number:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Lot_Number}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Farmer Name:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Farmer_Name}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Mobile Number:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Mobile}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Zone Name:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Zone_Name}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Branch Name:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Branch_Name}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Vendor:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Vendor}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Shed Type:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Shed_Type}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Hatch Date:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Hatch_Date}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Chicks Housed Quantity:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Placed_Qty}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  CA:
                </Typography>
                <Typography variant="body2">{storedLeadDetails.CA}</Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Age:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Age_SAP}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Diff:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Diff}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  First Week Mortality Quantity:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.first_Week_M}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  First Week Mortality Percentage:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.First_Week_Mortality_Percentage}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Total Mortality Quantity:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Total_Mortality}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Total Mortality Percentage:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Total_Mortality_Percentage}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Lifting EA:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Lifting_EA}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Lifting Percentage:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Lift_Percentage}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Average Lifted Weight:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Avg_Lift_Wt}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Balance Birds:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Bal_Birds}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Average Body Weight:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.ABWT}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  BWT Age:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.BWT_Age}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Feed Cons:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Feed_Cons}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Previous Grade:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Prev_Grade}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  FCR:
                </Typography>
                <Typography variant="body2">{storedLeadDetails.FCR}</Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Line:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Line}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4} xl={4} className={`flex`}>
                <Typography
                  variant="body2"
                  className={`${auditFormStyles.label_margin}`}
                >
                  Hatchery Name:
                </Typography>
                <Typography variant="body2">
                  {storedLeadDetails.Hatchery_Name}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>

      {/* List of Added Remarks */}
      <Card className="mt-2">
        <CardHeader
          title="List of Added Remarks"
          sx={{
            padding: "10px",
            borderBottom: "1px solid #ccc",
          }}
          
          titleTypographyProps={{
            fontSize: "1rem",
            fontWeight: 600,
          }}
          className={auditFormStyles.accordian_heading}
        />

        <CardContent>
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: 2,
              borderRadius: "8px",
              margin: "16px 0",
            }}
          >
            <Table
              sx={{ minWidth: 650, height: "100%", tableLayout: "fixed" }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
                  <TableCell width={50}>SNo</TableCell>
                  {columns.map((column) => (
                    <TableCell
                      key={column.field}
                      align={column.headerAlign || "left"}
                      style={{ width: column.width }}
                    >
                      {column.headerName}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {row.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={columns.length + 1} align="left">
                      No data available yet
                    </TableCell>
                  </TableRow>
                ) : (
                  row.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      {columns.map((column) => (
                        <TableCell
                          key={column.field}
                          align={column.headerAlign || "left"}
                        >
                          {row[column.field] === null ||
                          row[column.field] === undefined || row[column.field] === ""
                            ? "-" // Display "-" for empty data
                            : column.renderCell
                            ? column.renderCell(row[column.field])
                            : row[column.field]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {/* <AlertTitle>{alertTitle}</AlertTitle> */}
          {alertTitle}
        </Alert>
      </Snackbar>
    </>
  );
}

export default AuditDetailsPageComponent;
